import React from 'react'
import { Box, Button, Container, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
function MainSubscripe() {
    const { t } = useTranslation()
    return (
        <Container>
            <Box
                sx={{
                    margin: 'auto',
                    width: { md: "50%", xs: '100%' },
                    background: "#13103f",
                    height: { md: "135px", xs: '175px' },
                    borderRadius: "20px",
                    padding: "10px",
                    gap: { md: '16px', xs: '16px' }
                }}
                display={'flex'}
                flexWrap={"wrap"}
                // gap={{ md: 2, xs: 0 }}
                alignItems={'center'}
                justifyContent={'space-around'} >
                <Box>
                    <Typography
                        sx={{ color: 'white', fontSize: '1.5rem' }}
                        fontWeight={'bold'}>
                        {t("home.needService")}
                    </Typography>
                    <Typography
                        sx={{ color: 'white', fontSize: '1.25rem' }}
                        fontWeight={'bold'}>
                        {t("home.needServiceDesc")}
                    </Typography>
                </Box>
                <Link
                    to="https://whas.me/pEXYB3mg3Z"
                    target='_blank'
                    style={{
                        color: "inherit",
                        textDecoration: "none",
                        fontSize: '2.5rem',
                        fontWeight: "bold",
                    }}>
                    <Button
                        style={{
                            fontWeight: "bold", backgroundColor: "#76232d",
                            // height: "65px",
                            width: "fit-content",
                            fontSize: '1.25rem'

                        }}
                        sx={{ padding: 1 }}
                    >{t("home.SubscribeNow")}</Button>
                </Link>
            </Box>
        </Container>
    )
}

export default MainSubscripe